const firebaseConfig = {
  apiKey: "AIzaSyAd5i7ehBatrm-JmOIVrQMYVNYUANM4mdY",
  authDomain: "travel-guru-e1d15.firebaseapp.com",
  databaseURL: "https://travel-guru-e1d15.firebaseio.com",
  projectId: "travel-guru-e1d15",
  storageBucket: "travel-guru-e1d15.appspot.com",
  messagingSenderId: "898489697949",
  appId: "1:898489697949:web:62d511dd35e3e26fecb674"
};


export default firebaseConfig